import './CategoryEditBlocks.scss';
import { useState } from 'react';
import { Icon, LoadingCircle, ValidationTooltip } from '@gplibraries/react/components';
import { useMutation } from '@tanstack/react-query';
import { actions } from './categoriesReducer.js';
import { useTokenProvider, useConfig } from '@gplibraries/react/hooks';
import { updateCategory, createCategory } from '@gplibraries/react/api';

export default function SubcategoryEditRow(props) {

  const { subcategory, setShowNewRow, parentCategory, children, dispatch } = props;

  const { dealerAccessApiScope, dealerAccessApiHost } = useConfig();
  const [name, setName] = useState(() => subcategory?.name ?? '');
  const [isEditing, setIsEditing] = useState(() => subcategory === 'new' ? true : false);
  const [validationError, setValidationError] = useState(null);
  const getToken = useTokenProvider({ scopes: [dealerAccessApiScope]});

  const { isPending: nameChangeLoading, mutate: updateName } = useMutation({
    mutationFn: () => getToken()
      .then(token => updateCategory(dealerAccessApiHost, token?.accessToken, {
        id: subcategory.id,
        type: subcategory.type,
        name: name
      }))
      .then(res => res.json()),
    onError: (err) => {
      console.error(err)
      // display error to user
    },
    onSuccess: (data) => {
      dispatch({
        type: actions.UPDATE_SUBCATEGORY,
        payload: data.data
      })
    }
  })

  const { isPending: addCategoryLoading, mutate: addNewCategory } = useMutation({
    mutationFn: () => getToken()
      .then(token => createCategory(dealerAccessApiHost, token?.accessToken, {
        parent: parentCategory,
        name: name,
        type: parentCategory.type
      }))
      .then(res => res.json()),
    onError: (err) => {
      console.error(err)
      setShowNewRow(false)
      // display error to user
    },
    onSuccess: (data) => {
      dispatch({
        type: actions.ADD_SUBCATEGORY,
        payload: data.data
      })
      setShowNewRow(false)
    }
  })

  function handleNameChange(event) {
    // // clear any validation error once user starts typing again
    if (validationError) {
      setValidationError(null);
    }
    setName(event.target.value);
  }

  function handleNameChangeCancel() {
    if (subcategory === 'new') {
      setName('');
      setIsEditing(false);
      setShowNewRow(false);
    } else {
      setName(subcategory.name);
    }
    setIsEditing(false);
    setValidationError(null);
  }

  function submitNameChange(event) {
    event.preventDefault();

    // Name cannot be empty
    if (name.length === 0) {
      setValidationError('Name cannot be empty.');
      return;
    }

    // Only certain special characters allowed - currently arbitrary, may need to
    // change if conflicts with Drupal arise.
    if (!name.match(/^[A-Za-z\s&\-:\+()\d\.]+$/)) {
      setValidationError('Name contains invalid characters.');
      return;
    }

    if (subcategory === 'new') {
      addNewCategory();
    } else {
      updateName();
    }

    setIsEditing(false);
  }

  return (
    <div className="flex-row full fill subcategory-row">
      <div className="flex-row space middle subcategory-row-wrapper">

        <div className={'subcategory-name'}>

          <span>

            {isEditing && <>
              <form onSubmit={submitNameChange}>
                <input
                  type={'text'}
                  value={name}
                  onChange={handleNameChange}
                  autoFocus
                />

                {validationError &&
                  <ValidationTooltip message={validationError}/>
                }

                <button
                  type={'submit'}
                  className={'icon-only'}
                  title={'Change category name'}
                >
                  <Icon glyph={'check-circle'}/>
                </button>
                <button
                  className={'icon-only'}
                  title={'Cancel changes'}
                  onClick={handleNameChangeCancel}
                >
                  <Icon glyph={'x-circle'} className={'danger'}/>
                </button>
              </form>
            </>}
            {!isEditing && <>
              {(nameChangeLoading || addCategoryLoading) ? name : subcategory.name}
              <button
                className={'icon-only'}
                title={'Edit category name'}
                onClick={() => setIsEditing(true)}
              >
                {!nameChangeLoading && <Icon glyph={'pencil-square'}/>}
              </button>
            </>}
            {(nameChangeLoading || addCategoryLoading) && <LoadingCircle/>}
          </span>
        </div>

        {children}

      </div>
    </div>
  );
}